import { Injectable, inject } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {Member} from '../model/member';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MemberStateService {
  private storage = inject(StorageService);
  private translateService = inject(TranslateService);

  private localStorageMember: Member = null;
  private memberSubject = new BehaviorSubject<Member>(this.localStorageMember);
  private isOpenedInNewTabSubject = new BehaviorSubject(false);

  constructor() {
    if (typeof this.storage.getMember() !== 'undefined') {
      if (this.storage.getMember() !== null) {
        try {
          this.localStorageMember = JSON.parse(this.storage.getMember());
        } catch (e) {
          console.warn(e);
        }
      }
      this.memberSubject = new BehaviorSubject<Member>(this.localStorageMember);
    }

    this.translateService.onLangChange.subscribe({
      next: (event: { lang: string }) => {
        this.storage.setLanguage(event.lang);
      },
      error: (err: unknown) => console.error('[MemberStateService] Language change error:', err)
    });
  }

  getMember() {
    return this.memberSubject.asObservable();
  }

  setMember(member: Member) {
    const m = {...member};
    this.storage.setMember(JSON.stringify(m));
    this.memberSubject.next(m);
  }

  getIsOpenedInNewTabSubject() {
    return this.isOpenedInNewTabSubject.asObservable();
  }

  setIsOpenedInNewTabSubject(openedInNewTab: boolean) {
    this.isOpenedInNewTabSubject.next(openedInNewTab);
  }
}
